/** 获取权限
 * 控制功能权限
 */
export const getPermission = (permissionCode: string | string[]) => {
  let userInfo;
  if (sessionStorage.getItem('USER_BASE_INFO') === 'undefined') {
    userInfo = {};
  } else {
    userInfo = JSON.parse(sessionStorage.getItem('USER_BASE_INFO') || '{}');
  }
  const PERMISSIONS_MAP = userInfo?.permissionCodes || [];
  if (!permissionCode || !PERMISSIONS_MAP.length) {
    return true;
  }
  if (Array.isArray(permissionCode)) {
    return permissionCode.some((code) => PERMISSIONS_MAP.includes(code));
  }
  return PERMISSIONS_MAP.includes(permissionCode);
};

/** 获取当前用户 adminType（'ROOT' | 其他） */
export const getAdminType = (): string => {
  const raw = sessionStorage.getItem('USER_BASE_INFO');
  if (!raw || raw === 'undefined') return '';
  try {
    return JSON.parse(raw)?.adminType || '';
  } catch {
    return '';
  }
};

/**
 * 判断路由是否对当前用户可见
 * 规则：permissionKey 通过 + adminType 要求通过（如有）
 */
export const canAccessRoute = (route: {
  permissionKey?: string | string[];
  adminType?: 'ROOT';
}): boolean => {
  if (!route) return true;
  if (route.permissionKey && !getPermission(route.permissionKey)) return false;
  if (route.adminType && getAdminType() !== route.adminType) return false;
  return true;
};
